import { jsx as _jsx } from "react/jsx-runtime";
export function withNonTrellisComponent(Component) {
  return function (props) {
    const newProps = Object.assign({}, props, {
      isTrellisCompatibleComponent: false
    });
    return /*#__PURE__*/_jsx(Component, Object.assign({}, newProps));
  };
}
export function withTrellisComponent(Component) {
  return function (props) {
    const newProps = Object.assign({}, props, {
      isTrellisCompatibleComponent: true
    });
    return /*#__PURE__*/_jsx(Component, Object.assign({}, newProps));
  };
}
export function withNonTrellisForwardRefRenderFunc(render) {
  return function (props, ref) {
    const newProps = Object.assign({}, props, {
      isTrellisCompatibleComponent: false
    });
    return render(Object.assign({}, newProps), ref);
  };
}
export function withTrellisForwardRefRenderFunc(render) {
  return function (props, ref) {
    const newProps = Object.assign({}, props, {
      isTrellisCompatibleComponent: true
    });
    return render(Object.assign({}, newProps), ref);
  };
}